<template>
	<div class="top_common" :class="{ top_common_other: tip == 1 }" v-show="backShow">
		<img src="@/assets/image/internal/back.webp" alt="" @click="handleBack" />
		<h1>{{ name }}</h1>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				backShow: true,
			}
		},
		props: {
			name: String,
			tip: Number,
		},
		created() {},
		mounted() {},
		methods: {
			handleBack() {
				window.android?.closePage()
			},
		},
	}
</script>
<style lang="scss" scoped>
	.top_common {
		// height: 1.46rem;
		// position: fixed;
		display: flex;
		align-items: center;
		padding: 0.73rem 0.32rem 0.23rem 0.32rem;
		box-sizing: border-box;
		width: 100%;
		background: #f9f9fe;
		// justify-content: flex-start;
		z-index: 999;
		h1 {
			width: calc(100% - 0.88rem);
			font-size: 0.36rem;
			text-align: center;
			margin: 0;
			font-weight: 500;
			color: #ffffff;
		}
		img {
			width: 0.24rem;
			height: 0.36rem;
		}
	}
	.top_common_other {
		background: #8533d9;
	}
</style>
